function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5639 55.6352L66.9258 49.5078L30.7031 28.6444V82.626L127.297 138.261V84.2796L107.978 73.1525L102.43 69.9577L88.6594 62.0255L77.5639 55.6352Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M77.5637 0L32.1387 26.1637L66.2075 45.7865L77.5637 52.3274V0Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M102.43 66.6499V39.6591L125.861 26.1637L80.4355 0V53.9816L89.2333 59.0486L102.43 66.6499Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M127.297 80.9719V28.6444L105.302 41.3128V68.3035L109.701 70.8373L127.297 80.9719Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.30849 152.437C4.23197 152.437 5.51507 152.527 6.59502 153.246C7.85561 154.077 8.46339 155.514 8.46339 156.884C8.46339 157.76 8.23829 159.107 7.00021 160.162C5.80716 161.173 4.43402 161.33 3.33045 161.33H2.29607V167.416H0V152.437H3.30849ZM2.29607 159.219H3.33155C5.31247 159.219 6.25791 158.254 6.25791 156.861C6.25791 156.03 5.92081 154.548 3.30904 154.548H2.29607V159.219Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M26.7419 152.437V165.26H31.1539V167.416H24.4458V152.437H26.7419Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M56.2991 163.8H49.8831L48.2398 167.416H45.7637L53.2372 151.562L60.3505 167.416H57.8743L56.2991 163.8ZM55.3757 161.644L53.1471 156.569L50.828 161.644H55.3757Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M79.3037 154.593V167.415H77.007V154.593H73.5635V152.437H82.7478V154.593H79.3037Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M106.834 154.593H100.846V158.388H106.654V160.544H100.846V165.26H106.834V167.416H98.5503V152.437H106.834V154.593Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M130.583 163.8H124.167L122.524 167.416H120.048L127.521 151.562L134.635 167.416H132.159L130.583 163.8ZM129.66 161.644L127.431 156.569L125.112 161.644H129.66Z",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M149.176 152.437V161.464C149.176 162.273 149.198 163.261 149.649 164.047C150.099 164.811 151.112 165.597 152.44 165.597C153.768 165.597 154.781 164.81 155.231 164.047C155.681 163.261 155.704 162.273 155.704 161.464V152.437H158V162.071C158 163.261 157.752 164.699 156.604 165.956C155.817 166.81 154.488 167.708 152.44 167.708C150.392 167.708 149.063 166.81 148.276 165.956C147.127 164.699 146.88 163.261 146.88 162.071V152.437H149.176Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M43.8711 179.405V183.783C44.3455 183.138 45.057 182.928 45.7027 182.928C46.507 182.928 47.2312 183.23 47.7457 183.717C48.3123 184.256 48.668 185.057 48.668 186.031C48.668 186.938 48.3523 187.779 47.7457 188.384C47.2312 188.91 46.5993 189.186 45.729 189.186C44.6881 189.186 44.1615 188.699 43.8711 188.279V188.989H41.9736V179.405H43.8711ZM44.1742 184.993C43.9502 185.23 43.7525 185.571 43.7525 186.071C43.7525 186.557 43.9633 186.912 44.1874 187.123C44.4904 187.412 44.9121 187.556 45.2679 187.556C45.5978 187.556 45.9662 187.425 46.2567 187.149C46.5334 186.886 46.7179 186.505 46.7179 186.071C46.7179 185.598 46.5334 185.216 46.2567 184.954C45.953 184.665 45.6242 184.559 45.2415 184.559C44.833 184.559 44.4778 184.677 44.1742 184.993Z",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M55.6377 188.239L52.8311 183.126H55.0184L56.6787 186.308L58.2995 183.126H60.4347L55.7036 192H53.569L55.6377 188.239Z",
  fill: "white"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M72.8335 188.989L74.2434 180.22H75.9301L78.1174 185.465L80.3048 180.22H81.9914L83.4014 188.989H81.3721L80.6737 183.757L78.4732 188.989H77.7611L75.5606 183.757L74.8622 188.989H72.8335Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M92.2167 180.221V187.28H94.9449V188.99H90.1875V180.221H92.2167Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M103.957 180.221V188.99H101.928V180.221H103.957Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M114.802 181.929V188.99H112.773V181.929H110.863V180.221H116.713V181.929H114.802Z",
  fill: "white"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 192,
    viewBox: "0 0 158 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8309c122.svg";
export { ForwardRef as ReactComponent };